export default {
    error: {
        points_program_inactive: "{$0} pausada pois utiliza o filtro \"{$1}\" relacionado ao programa de pontos que está desativado. Remova o filtro ou ative o programa de pontos antes de reativar.",
        points_program_inactive_trigger: "{$0} pausada pois utiliza um gatilho vinculado ao programa de pontos que está desativado. Reative o programa de pontos ou altere o gatilho antes de reativar.",
        points_program_inactive_action: "{$0} pausada pois possui uma ação vinculada ao programa de pontos que está desativado. Reative o programa de pontos ou remova a ação antes de reativar.",
        segment_unavailable: "{$0} pausada pois utiliza o filtro \"{$1}\" que possui erros ou está indisponível. Corrija o segmento ou remova o filtro antes de reativar.",
        generic: "Erro ao ativar {$0}. Entre em contato com o suporte se o problema continuar.",
        short: {
            points_program_inactive: "Filtro indisponível: o programa de pontos está desativado.",
            points_program_inactive_trigger: "Gatilho indisponível: o programa de pontos está desativado.",
            points_program_inactive_action: "Ação indisponível: o programa de pontos está desativado.",
            segment_unavailable: "Público indisponível: o segmento possui erros.",
            generic: "Erro ao ativar {$0}.",
        },
    },
    action_names: {
        coupon: "cupom",
        feedback_link: "link",
        auth_link: "link de autenticação",
        notification: "notificacao",
        add_points: "pontos",
        data_sets: "conjunto de dados",
        calculator: "calculadora",
    },
    action_alias: {
        notification: "notificacao",
        coupon: "cupom",
        cashback: "cashback",
        coupon_external: "cupom_externo",
        feedback_link: "link",
        add_points: "pontos",
        auth_link: "link_login",
        task: "tarefa",
        update_field: "atualizar_campo",
        web_hook: "webhook",
        ai_content: "conteudo_ia",
        move_client_stage: "mover_etapa",
        add_to_segment: "add_to_segment",
        remove_from_segment: "remove_from_segment",
        plugin_action: "acao_plugin",
        smart_insertion: "insercao",
        remove_smart_insertion: "remover",
        data_sets: "dados",
        calculator: "calculadora",
        wait: "espera",
        kevichat_internal_chat_create: "abrir_conversa",
        kevichat_internal_chat_message: "postar_conversa",
    },
    triggers: {
        inactivity: "Inatividade",
        new_order: "Novo pedido",
        data_filled: "Perfil completado",
        reward_reached: "Recompensa atingida",
        feedback_received: "Opinião recebida",
        specific_date: "Agendamento",
        coupon_expiring: "Cupom expirando",
        birthday: "Aniversário",
        too_long_on_external_status: "Pedido estagnado",
        joined_segment: "Entrou no segmento",
        left_segment: "Saiu do segmento",
        periodic: "Periódico",
        custom_event: "Evento personalizado",
        custom_event_without_order: "Evento sem pedido",
        order_status_changed: "Status atualizado no pedido",
        reward_used: "Recompensa usada",
        product_group_stock: "Produto acabando",
        enter_stage: "Entrou no estágio",
        task_moved_to_column: "Tarefa movida para coluna",
        quotation_status_changed: "Status atualizado no orçamento",
        new_quotation: "Novo orçamento",
        quotation_without_order: "Oportunidade não aproveitada",
        quotations_too_long_status: "Orçamento estagnado",
        quotation_expired: "Orçamento expirado",
        client_date: "Data do cliente",
        order_status_change: "Status atualizado no pedido",
        manual: "Disparo manual",
    },
    goals: {
        orders: "compra",
        answers: "resposta de formulário",
        coupons_codes: "resgate de cupom",
        rewards_transactions: "resgate de recompensa",
        custom_events: "evento personalizado",
    },
    list: {
        page_title: "Kevi | Ações de Marketing",
        page_header: "Ações de Marketing",
        add_action_button: "Adicionar Ação",
        no_credits_alert: "Seus créditos terminaram e suas automações não estão funcionando.",
        low_credits_alert: "Seus créditos estão terminando, talvez suas automações deixem de funcionar em breve.",
        confirm_delete_title: "Tem certeza que deseja deletar <b>\"{$0}\"</b>?",
        confirm_delete_body: "Essa automação deixará de funcionar assim que removida.",
        confirm_play_title: "Tem certeza que deseja retomar <b>\"{$0}\"</b>?",
        confirm_play_body: "Após retomada, a automação voltará a funcionar e poderá ser pausada novamente a qualquer momento.",
        confirm_pause_title: "Tem certeza que deseja pausar <b>\"{$0}\"</b>?",
        confirm_pause_body: "Após pausada, a automação deixará de funcionar e poderá ser retomada novamente a qualquer momento.",
        confirm_duplicate_title: "Gostaria de duplicar <b>\"{$0}\"</b>?",
        confirm_duplicate_body: "Após duplicação, a automação estará pausada e você deverá ajustar a configuração.<br /><br />Quer duplicar a automação?",
        confirm_duplicate_campaign_body: "Para evitar envios acidentais, você precisará selecionar uma nova data para a campanha após duplicar.<br /><br />Gostaria de duplicar a campanha?",
        campaign_label: "Campanha",
        automation_label: "Automação",
        messages_label: "mensagens",
        purchases_label: "compras",
        answers_label: "respostas",
        conversions_label: "conversões",
        play_success: "Ação iniciada com sucesso!",
        pause_success: "Ação pausada com sucesso!",
        action_error: "Ocorreu um erro ao executar essa ação!",
        duplicate_success: "Automação duplicada com sucesso!",
        filters: {
            period: "Período",
            title: "Título da automação",
            type: "Tipo",
            type_campaigns: "Campanhas",
            type_automations: "Automações",
            status: "Status",
            status_active: "Ativas",
            status_paused: "Pausadas",
            status_deleted: "Deletadas",
        },
        aria: {
            edit_automation: "Editar automação {$0}",
            actions_group: "Ações para {$0}",
            duplicate_automation: "Duplicar automação {$0}",
            report_automation: "Relatório da automação {$0}",
            resume_automation: "Retomar automação {$0}",
            pause_automation: "Pausar automação {$0}",
            remove_automation: "Remover automação {$0}",
        },
        tooltip: {
            duplicate: "Duplicar automação",
            report: "Relatório da automação",
            edit: "Editar automação",
            remove: "Remover automação",
            resume: "Retomar automação",
            pause: "Pausar automação",
        },
    },
    form: {
        page_title: "Kevi | Automações",
        editing_warning: "Por sua segurança, essa ação não será executada enquanto você está editando.",
        trigger_points_program_inactive_warning: "Esta automação utiliza um gatilho vinculado ao programa de pontos, que está desativado. Para que ela volte a funcionar, reative o programa de pontos ou altere o gatilho.",
        filter_points_program_inactive_warning: "Esta automação utiliza o filtro de saldo de pontos, mas o programa de pontos está desativado. Remova o filtro ou reative o programa de pontos para poder ativar a automação.",
        segment_with_error: "com erro",
        confirm_overwrite_title: "\"{$0}\" estava editando esta automação recentemente e talvez você sobrescreva o seu trabalho.",
        confirm_overwrite_body: "Deseja continuar mesmo assim?",
        confirm_edit_active_title: "Esta campanha já começou, deseja mesmo alterar seus dados?",
        confirm_edit_active_body: "Após inicializada, a edição dela pode causar envios duplicados.",
        title_new: "Adicionar",
        title_edit: "Editar",
        title_page_suffix: "Ação",
        title_label: "Título",
        title_help: "Escolha um título para identificar a sua ação",
        goal_label: "Objetivo",
        goal_help: "Qual o objetivo dessa campanha?",
        select: "Selecione",
        goals: {
            orders: "Gerar pedido",
            answers: "Obter opinião",
            custom_event_clients: "Executar evento personalizado",
            loyalty_points_earned: "Ganhar pontos de fidelidade",
            reward_redemptions: "Resgate de recompensas",
        },
        select_option: "Selecione uma das Opções",
        any_option: "Qualquer uma das Opções",
        conversion_period_help: "Qual o período de conversão (Em dias)?",
        zero_days: "0 dias",
        trigger_label: "Gatilho",
        trigger_help: "Escolha o gatilho que irá iniciar a ação",
        triggers: {
            inactivity: "Inatividade",
            new_order: "Novo pedido",
            order_status_change: "Status atualizado no pedido",
            product_group_stock: "Produto acabando",
            periodic: "Data Periódica",
            too_long_on_external_status: "Pedido Estagnado",
            client_date: "Data do cliente",
            data_filled: "Perfil completado",
            custom_event: "Realizou Evento Personalizado",
            custom_event_without_order: "Evento sem pedido",
            coupon_expiring: "Cupom expirando",
            reward_reached: "Alcançar recompensa",
            reward_used: "Recompensa utilizada",
            feedback_received: "Nova opinião",
            joined_segment: "Entrou no segmento",
            left_segment: "Deixou o segmento",
            enter_stage: "Entrou no estágio",
            task_moved_to_column: "Tarefa movida para coluna",
            birthday: "Aniversário",
            manual: "Disparo manual",
            specific_date: "Campanha",
            new_quotation: "Novo orçamento",
            quotation_status_change: "Status atualizado no Orçamento",
            quotations_too_long_status: "Orçamento estagnado",
            quotation_expired: "Orçamento expirado",
            quotation_without_order: "Oportunidade não aproveitada",
        },
        action_modal: {
            identification_label: "Identificação:",
            identification_help: "Escolha um id para essa ação, o que você digitar aqui poderá ser usado para acessar propriedades dessa ação em notificações futuras nessa mesma automação.",
            identification_error: "A identificação deve ter no máximo 25 caracteres",
            identification_duplicate_error: "Por favor escolha uma identificação ainda não utilizada.",
            cancel_button: "Cancelar",
            add_button: "Adicionar",
        },
        add_action_modal_title: "Adicionar Ação",
        action_types: {
            generate_coupon: "Gerar Cupom",
            generate_coupon_tray: "Gerar Cupom na Tray",
            generate_coupon_shopify: "Gerar Cupom na Shopify",
            calculate_cashback: "Calcular Cashback",
            generate_feedback_link: "Gerar Link de Opinião",
            generate_auth_link: "Gerar Link de Autenticação",
            generate_notification: "Gerar Notificação",
            add_points: "Adicionar Pontos",
            add_task: "Adicionar Tarefa",
            update_client_field: "Atualizar informação do cliente",
            webhook: "WebHook",
            generate_ai_content: "Gerar conteúdo com IA",
            move_client_stage: "Mover o cliente na jornada",
            add_to_segment: "Adicionar ao segmento",
            remove_from_segment: "Remover do segmento",
            smart_insertion: "Inserção Inteligente",
            remove_smart_insertion: "Remover Inserção",
            select_data_sets: "Selecionar Conjunto de Dados",
            calculator: "Calculadora",
            wait: "Aguardar",
            new_notification: "Nova Notificação",
        },
        filter_audience_title: "Filtre o público da ação",
        audience_label: "Público:",
        configure_actions_title: "Configurar Ações",
        add_button: "Adicionar",
        action_config_help: "Quais as ações devem ser executadas quando o fluxo for executado?",
        confirm_delete_action_title: "Tem certeza que deseja remover a ação {$0}?",
        confirm_delete_action_body: "Essa ação deixará de funcionar assim que removido.",
        confirm_save_campaign_title: "Essa campanha será enviada para todos os seus clientes.",
        confirm_save_campaign_body: "Tem certeza que deseja continuar?",
        saving: "Salvando...",
        save_and_activate: "Salvar e Ativar",
        save_draft: "Salvar como rascunho",
        a_user: "Um usuário",
        save_error_message: "Erro ao salvar automação.",
        filters: {
            avg_ticket: "Ticket médio",
            orders_amount: "Número de pedidos",
            customer_profile: "Perfil do cliente",
            profile_complete: "Com cadastro completo",
            profile_incomplete: "Sem cadastro completo",
            points_balance: "Saldo de Pontos",
            client_segments: "Segmento do cliente",
            client_segments_not: "Não está no segmento",
            last_order_period: "Período do último pedido",
            min_period_between_execution: "Tempo mínimo entre execuções",
            branch: "Filiais",
            last_branch: "Filial do último pedido",
            clients_limit: "Limite de clientes",
            value: "Valor",
            period_between_executions: {
                label: "Dias",
                suffix: "dias",
                check_label: "Verificar:",
                check_options: {
                    this: "Essa automação",
                    all: "Qualquer automação",
                },
                close_button: "Fechar",
                not_informed: "Não informado",
                check_suffix: {
                    all: " ( todas ) ",
                    this: " ( essa )",
                },
            },
        },
        actions: {
            auth_link: {
                title: "Gerar um link para autenticação",
                description: "Cria um link que leva o cliente já autenticado à area do cliente, onde ele poderá consultar seus pontos e vouchers.",
            },
            add_points: {
                title: "Adicionar pontos ao cliente",
                description: "Essa ação permite você adicionar pontos ao perfil do cliente em que ela for executada.",
                points_label: "Quantos pontos você quer adicionar?",
                use_snippets_label: "Usar tags de substituição neste campo",
                snippet_placeholder: "Ex.: [[calculadora.resultado]]",
                snippets_help: "Escolha uma tag que resulte em um número. O valor é arredondado e, se for zero ou negativo, nenhum ponto é adicionado:",
            },
            cashback: {
                title: "Calcular Cashback",
                description: "Calcular o valor de cashback para o cliente.",
                percentage_label: "Quantos % dessa compra você quer voltar ao cliente?",
                max_discount_label: "Valor máximo do desconto em %",
                simulation_button_open: "Fechar simulação",
                simulation_button_closed: "Simular cashback",
                example_value_label: "Valor de compra do cliente em R$",
                example_text: "Exemplo: Se o cliente comprar <strong>R${$0}</strong> receberá <strong>R${$1}</strong> em cashback para usar em compras acima de <strong>R${$2}</strong>",
            },
            coupon: {
                title: "Gerar um cupom",
                description: "Criar um novo cupom de desconto para o cliente.",
                validity_label: "Qual a validade do cupom?",
                validity_unit: "Dias",
                min_wait_label: "Tempo mínimo para uso?",
                min_wait_help: "Qual o tempo mínimo que o cliente precisa esperar antes de poder utilizar este cupom?",
                min_wait_unit: "Horas",
                calculation_label: "Como é calculado o valor do cupom?",
                calculation_options: {
                    fixed_amount: "Valor fixo",
                    percentage: "Desconto em porcentagem",
                    cashback: "Cashback",
                    other: "Outros",
                },
                discount_label: "Qual o valor de desconto do cupom?",
                use_snippets_label: "Usar tags de substituição neste campo",
                min_purchase_label: "Valor mínimo para compra",
                cashback_percentage_label: "Quantos % dessa compra você quer voltar ao cliente?",
                cashback_max_discount_label: "Valor máximo do desconto em %",
                cashback_example_text: "Exemplo: Se o cliente comprar <strong>R${$0}</strong> receberá <strong>R${$1}</strong> em cashback para usar em compras acima de <strong>R${$2}</strong>",
                description_label: "Descrição do cupom para o cliente",
                snippets_help: "Você pode usar as seguintes tags de substituição inteligente na sua solicitação:",
                token_copied: "Token copiado com sucesso!",
            },
            coupon_external: {
                title: "Gerar um cupom",
                description: "{$0} em pedidos acima de {$1}",
                validity_label: "Qual a validade do cupom? (Em dias)",
                calculation_label: "Como é calculado o valor do cupom?",
                calculation_options: {
                    fixed_amount: "Valor fixo",
                    percentage_amount: "Percentual",
                    cashback: "Cashback",
                },
                fixed_amount_label: "Qual o valor do cupom?",
                percentage_amount_label: "Qual o desconto do cupom?",
                cashback_percentage_label: "Quantos % dessa compra você quer voltar ao cliente?",
                cashback_max_discount_label: "Valor máximo do desconto em %",
                min_purchase_label: "Valor mínimo para compra",
                discount_scope_label: "Onde o desconto incide na Shopify?",
                discount_scope_help: "Pedido é o padrão. Produto incide só nos itens e pode combinar com desconto de pedido.",
                discount_scope_options: {
                    order: "Desconto de pedido",
                    product: "Desconto de produto",
                },
            },
            task: {
                title: "Gerar uma tarefa para o time",
                description: "Criar uma nova tarefa para um membro do time realizar.",
                snippets_help: "Você pode usar as seguintes tags de substituição inteligente em todos os campos da tarefa:",
                board_label: "Em qual quadro?",
                board_placeholder: "Selecione um quadro",
                task_title_label: "Título da tarefa",
                deadline_label: "Prazo da tarefa (em dias)",
                description_label: "Descrição",
                has_message_suggestion_label: "Adicionar sugestão de mensagem",
                use_ai_label: "Utilizar IA para gerar mensagem",
                message_suggestion_label: "Sugestão de Mensagem",
                ai_prompt_label: "Explique como deve ser a mensagem.",
                ai_prompt_help: "A mensagem sugerida será gerada utilizando inteligência artificial. Alimentaremos a IA com o histórico de compras do cliente e dados do cliente.",
                responsible_label: "Responsável",
                responsible_help: "Quem deve ser o responsável pela tarefa?",
                assign_methods: {
                    manual: "Selecionar manualmente",
                    by_role: "Distribuir por cargo",
                    by_custom_field: "Campo do cliente",
                },
                role_label: "Cargo",
                role_placeholder: "Selecionar cargo",
                branch_label: "Filial",
                branch_rules: {
                    last: "Última visitada",
                    first: "Primeira visitada",
                    all: "Todas",
                },
                custom_field_label: "Campo do cliente",
                custom_field_placeholder: "Selecionar campo do cliente",
                user_label: "Usuário",
                user_placeholder: "Selecionar usuário",
                token_copied: "Token copiado com sucesso!",
            },
            update_field: {
                title: "Atualizar campos do cliente",
                description: "Atualize dinâmicamente informações do cliente.",
                snippets_help: "Você pode usar as seguintes tags de substituição inteligente nos campos:",
                field_label: "Qual campo quer atualizar?",
                field_placeholder: "Selecione o campo",
                update_rule_label: "Como atualizar?",
                update_rules: {
                    always_replace: "Substituir sempre",
                    set_if_empty: "Preencher se vazio",
                },
                fill_rule_distribute: "Distribuir por cargo",
                fill_rule_order_field: "Preencher com campo do pedido",
                fill_rule_manual: "Informar manualmente",
                distribute_help: "O usuário será selecionado aleatoriamente de acordo com os filtros abaixo:",
                branch_label: "Filial",
                branch_placeholder: "Selecione uma opção",
                branch_options: {
                    any: "Qualquer",
                    last: "Filial do último pedido",
                    first: "Filial do primeiro pedido",
                },
                role_label: "Cargo",
                role_placeholder: "Selecione uma opção",
                role_any: "Qualquer",
                select_option_placeholder: "Selecione uma opção",
                value_label: "Qual o valor?",
                add_field_button: "Adicionar Campo",
                token_copied: "Token copiado com sucesso!",
                user_manual_label: "Qual usuário?",
                user_manual_help: "Informe o id ou o e-mail de um usuário, ou uma tag de substituição que resulte em um deles. Se o valor não corresponder a um usuário ativo, o passo falha.",
                user_manual_pick_user: "Ou escolha um usuário para preencher o id",
            },
            web_hook: {
                title: "Executar WebHook",
                description: "Essa ação faz uma chamada POST à URL informada.",
                url_label: "Qual URL você quer chamar?",
                request_body_title: "Corpo da requisição",
                field_key_label: "Campo (chave)",
                field_key_placeholder: "Ex: nome",
                field_value_label: "Valor",
                field_value_placeholder: "Ex: [[cliente.nome]]",
                add_field_button: "Adicionar campo",
            },
            ai_content: {
                title: "Gerar conteúdo com IA",
                description: "Essa ação permite você gerar conteúdo automaticamente com inteligência artificial.",
                model_label: "Qual modelo de inteligência artificial você quer utilizar?",
                models: {
                    basic: "Básico (Recomendado)",
                    advanced: "Avançado",
                },
                credits_label: "Créditos: {$0}",
                basic_description: "<strong>Básico:</strong> Indicado para a maioria dos cenários porém pode ter dificuldade em seguir instruções complexas. Maior risco de halucinação.",
                advanced_description: "<strong>Avançado:</strong> É um modelo mais preciso, com capacidade de se adequar à instruções mais complexas com menor risco de halucinação. Permite retornar múltiplos valores (ex: mensagem, imagem, cupom) para uso nas próximas ações da automação. Porém o custo por execução é mais alto. Recomendamos a utilização apenas quando o modelo básico não produzir um resultando adequado para você.",
                prompt_label: "O que você precisa? (Prompt)",
                prompt_help: "Descreva o conteúdo que gostaria como se tivesse pedindo para um funcionário que conhece todo o histórico desse cliente.",
                placeholder: "Ex: Escreva uma mensagem para [[cliente.nome]] oferecendo 10% de desconto com o código [[cupom.codigo_desconto]]. Se apresente como Fulano da Empresa X. Utilize um tom próximo e amigável.",
                snippets_help: "Você pode usar as seguintes tags de substituição inteligente na sua solicitação:",
                footer_help: "Além de poder usar os tokens acima a sua requisição será alimentada com os dados do cliente, histórico de compras e opiniões.",
                advanced_settings_label: "Configurações avançadas",
                output_values_label: "Valores adicionais de saída",
                output_values_help: "Defina campos extras que a IA deve retornar além do conteúdo principal. Cada campo ficará disponível como token nas próximas ações da automação. Ex: URL de uma imagem, código de cupom, etc.",
                field_id_placeholder: "Identificador (ex: imagem)",
                field_instruction_placeholder: "Instrução para a IA (ex: URL da imagem do produto)",
                remove_field_title: "Remover campo",
                add_field_button: "Adicionar campo",
            },
            move_client_stage: {
                title: "Mover o cliente na jornada",
                description: "Para que etapa devemos mover o cliente?",
            },
            segment_membership: {
                segment_label: "Segmento:",
                segment_placeholder: "Selecione um segmento",
                loading_segments: "Carregando segmentos...",
            },
            add_to_segment: {
                title: "Adicionar ao segmento",
                description: "Em qual segmento manual este cliente deve ser adicionado?",
            },
            remove_from_segment: {
                title: "Remover do segmento",
                description: "De qual segmento manual este cliente deve ser removido?",
            },
            smart_insertion: {
                title: "Inserção inteligente",
                description: "Essa ação permite você executar uma inserção inteligente no perfil do cliente.",
                insertion_name_label: "Nome da inserção",
                insertion_name_help: "O nome da inserção é utilizado para identificar a inserção na hora de desativar ela programaticamente. Você pode utilizar tokens de substituição no nome.",
                space_label: "Onde você quer fazer a inserção?",
                duration_label: "Duração (dias)",
                edit_html_button: "Editar HTML",
            },
            remove_smart_insertion: {
                title: "Remover inserção inteligente",
                description: "Essa ação permite você remover uma inserção inteligente do perfil do cliente.",
                space_label: "De onde você quer fazer a inserção?",
                space_options_any: "Qualquer lugar",
                insertion_name_label: "Nome da inserção",
                insertion_name_help: "O nome da inserção é utilizado para identificar a inserção na hora de desativar ela programaticamente. Você pode utilizar tokens de substituição no nome.",
            },
            data_sets: {
                title: "Selecionar Conjunto de Dados",
                description: "Essa ação permite você criar snippets a partir de dados no seu Conjunto de Dados.",
                dataset_label: "Qual Conjunto de Dados deseja utilizar?",
                selection_mode_label: "Como deseja selecionar a chave?",
                selection_modes: {
                    ai: "Selecionar com IA",
                    manual: "Informar manualmente",
                },
                key_label: "Qual chave deseja consultar?",
                snippets_help: "Você pode usar as seguintes tags de substituição inteligente na construção da chave:",
                ai_credits: "Créditos: {$0}",
                ai_prompt_label: "Instrução para a IA selecionar a chave:",
                ai_prompt_placeholder: "Informe o critério para a IA selecionar a chave mais adequada...",
                ai_prompt_help: "A IA analisará os dados do cliente e o conjunto de dados para selecionar a chave mais apropriada com base na instrução.",
            },
            wait: {
                title: "Aguardar",
                description: "Pause a automação por um período de tempo antes de continuar para a próxima ação.",
                duration_label: "Quanto tempo aguardar?",
                duration_help: "A automação vai pausar por esse tempo antes de executar a próxima ação.",
                days: "Dias",
                hours: "Horas",
                minutes: "Minutos",
            },
            calculator: {
                title: "Calculadora",
                description: "Calcule um valor a partir de uma fórmula com dados da automação. O resultado fica disponível para as próximas ações.",
                formula_label: "Fórmula matemática",
                syntax_valid: "Sintaxe válida",
                syntax_error: "Erro de sintaxe",
                insert: "Inserir:",
                formula_placeholder: "Ex: (a + b) * 0.10",
                help_operators: "Operadores disponíveis:",
                help_decimals: "Use ponto para decimais (ex: 10.5).",
                help_functions: "Funções recebem os valores entre parênteses, separados por vírgula. Ex:",
                fn_max: "Maior valor entre os argumentos",
                fn_min: "Menor valor entre os argumentos",
                fn_round: "Arredonda para o inteiro mais próximo",
                fn_abs: "Valor absoluto (sem sinal)",
                fn_floor: "Arredonda para baixo",
                fn_ceil: "Arredonda para cima",
                open_parenthesis: "Abrir parênteses",
                close_parenthesis: "Fechar parênteses",
                variables_label: "Mapeamento de variáveis",
                variables_empty: "Digite uma fórmula com letras para configurar as variáveis. Ex:",
                mapping_label: "Mapear para variável do sistema",
                mapping_placeholder: "Ex: [[pedido.{$0}]]",
                mapping_invalid: "Formato obrigatório:",
                example_label: "Valor de teste",
                preview_title: "Preview da simulação",
                interpretation: "Interpretação:",
                waiting_formula: "Aguardando fórmula...",
                result_label: "Resultado calculado:",
                error: "Erro",
                error_invalid_result: "Resultado inválido (divisão por zero ou indefinido).",
                error_syntax: "Erro de sintaxe. Verifique parênteses e operadores.",
                error_decimal_comma: "Use ponto para decimais (ex: 0.5). A vírgula só separa valores dentro de funções, como max(a, b).",
            },
            feedback_link: {
                title: "Gerar um link para formulário",
                description: "Criar um novo link único para o cliente poder enviar sua opinião.",
                form_label: "Formulário:",
                form_error: "Por favor selecione um formulário.",
                form_help: "Escolha um para essa ação, o formulário que você selecionar aqui será usado para gerar um link a ser enviado nessa mesma automação, e seus clientes responderão as perguntas contidas no mesmo.<br />Somente os formulário que contém perguntas serão listados.",
                select_form_placeholder: "Selecione um Formulário",
            },
            plugin: {
                use_snippets_label: "Usar tags de substituição neste campo",
                select_placeholder: "Selecione",
                select_parent_first: "Escolha primeiro o campo acima",
                select_empty: "Nada encontrado",
                snippets_help:
                    "Você pode usar as seguintes tags de substituição inteligente:",
                token_copied: "Token copiado com sucesso!",
            },
            notification: {
                title: "Enviar notificação",
                description: "Envia uma notificação para o cliente via sms, email ou whatsapp.",
                content_label: "Conteúdo",
                schedule_label: "Horários de envio:",
                schedule_help: "Respetar ou não configurações de horário definida no menu <a href='/#/notification-schedule' target='_blank'>Configurações > Horários de Envio de Notificações</a>",
                schedule_options: {
                    from_place: "Respeitar configurações de horário",
                    anytime: "Enviar a qualquer hora",
                },
                timeout_label: "Esperar:",
                timeout_help: "Quanto tempo esperar depois da ação anterior para enviar esta notificação? (Em minutos)",
                timeout_placeholder: "Ex: 10",
                method_label: "Enviar via?",
                method_help: "Caso seja escolhido o método e-mail e o cliente não possua email configurado, a notificação não será enviada.",
                method_placeholder: "Selecione o método",
                recipient_label: "Enviar para:",
                recipient_help: "Por padrão a notificação é enviada para o contato do próprio cliente. Escolha \"Outro\" para enviar para um endereço fixo ou definido por tags de substituição.",
                recipient_options: {
                    client_phone: "Telefone do cliente",
                    client_email: "E-mail do cliente",
                    custom_phone: "Outro telefone",
                    custom_email: "Outro e-mail",
                },
                recipient_address_label_phone: "Telefone de destino:",
                recipient_address_label_email: "E-mail de destino:",
                recipient_address_placeholder_phone: "Ex: +5511999999999 ou [[cliente.telefone]]",
                recipient_address_placeholder_email: "Ex: contato@empresa.com ou [[cliente.email]]",
                recipient_address_help: "Você pode usar as tags de substituição listadas abaixo. Se o valor final ficar vazio, a notificação não será enviada.",
                recipient_address_required_error: "Informe o endereço de destino.",
                sender_label: "Disparar por:",
                sender_placeholder: "Selecione o disparador",
                sender_default: "Disparador Padrão",
                no_default_sender: "Nenhum configurado",
                no_default_sender_warning: "Nenhum disparador padrão configurado. Clique na etiqueta ao lado do disparador para ",
                configure_default_sender_link: "definir um disparador padrão",
                template_placeholder: "Selecione o template",
                wpp_cloud: {
                    header: "Topo:",
                    image_preview: "Preview da imagem de exemplo:",
                    image_url_label: "{$0} - URL da imagem:",
                    header_preview_video: "Preview do vídeo de exemplo:",
                    header_preview_document: "Cabeçalho com documento (exemplo do template):",
                    header_preview_gif: "Preview do GIF de exemplo:",
                    header_media_url_video: "{$0} - URL do vídeo:",
                    header_media_url_document: "{$0} - URL do documento:",
                    header_media_url_gif: "{$0} - URL do GIF:",
                    header_document_example_hint:
                        "Este template usa documento no cabeçalho. Use um link https:// público, uma extensão conhecida (ex.: PDF) ou uma tag inteligente. Não há preview visual.",
                    document_url_accepted_hint:
                        "URL aceita para envio. O WhatsApp usará este link como mídia do cabeçalho do documento.",
                    document_filename_label: "Nome do arquivo (opcional)",
                    document_filename_help:
                        "Nome exibido opcional no aparelho do destinatário. Deixe em branco para usar o padrão do link.",
                    document_filename_placeholder: "ex.: nota-fiscal.pdf",
                    invalid_document_url_error:
                        "Informe uma URL http(s) válida ou um link cujo caminho termine com extensão de documento conhecida (ex.: .pdf).",
                    location_header_label: "Localização (cabeçalho)",
                    location_latitude_label: "Latitude",
                    location_latitude_placeholder: "ex.: -23.5505",
                    location_longitude_label: "Longitude",
                    location_longitude_placeholder: "ex.: -46.6333",
                    location_name_label: "Nome do local",
                    location_name_placeholder: "ex.: Loja centro",
                    location_address_label: "Endereço",
                    location_address_placeholder: "Endereço completo",
                    upload_button: "Faça upload aqui",
                    validating_media: "Validando mídia...",
                    custom_media_preview: "Preview da sua {$0}:",
                    media_types: {
                        image: "imagem",
                        video: "vídeo",
                        document: "documento",
                    },
                    required_error: "Este campo precisa ser preenchido",
                    video_not_supported: "Seu navegador não suporta o elemento de vídeo.",
                    body: "Corpo:",
                    body_help: "O conteúdo da mensagem é fixo para cada template, mas você pode preencher as variáveis abaixo:",
                    footer: "Rodapé:",
                    buttons: "Botões:",
                    buttons_label: "Botão ({$0}):",
                    quick_reply: "Resposta rápida: {$0}",
                    call_phone: "Ligar para telefone: {$0} ({$1})",
                    visit_website: "Visitar site: {$0} ({$1})",
                    marketing_opt_out: "Marketing Opt-Out: {$0}",
                    coupon_code: "Código do cupom: {$0}",
                    invalid_video_error: "URL de vídeo inválida ou vídeo não encontrado",
                    invalid_image_error: "URL inválida ou imagem não encontrada",
                    timeout_video_error: "Timeout: assumindo URL de vídeo válida",
                    timeout_url_error: "Timeout: assumindo URL válida",
                    url_empty_error: "URL vazia",
                    smart_tag_valid_success: "Tag de substituição inteligente identificada com sucesso",
                    smart_tag_not_found_error: "Tag de substituição inteligente não encontrada na lista de tokens disponíveis",
                    statuses: {
                        approved: "Aprovado",
                        rejected: "Rejeitado",
                        pending: "Pendente",
                    },
                },
                whatsapp: {
                    sender_number_label: "Enviar por qual número?",
                    selection_help: "Escolha um disparador WhatsApp específico, use o campo do cliente, ou a última filial visitada.",
                    select_manually: "Selecionar manualmente",
                    instance_placeholder: "Selecione uma instância",
                    client_field: "Campo do cliente",
                    select_client_field: "Selecionar campo do cliente",
                    custom_field_fallback_help: "Obs.: se o usuário retornado por esse campo não tiver WhatsApp vinculado, será usado o Disparador Padrão.",
                    last_branch: "Última filial visitada",
                    last_branch_fallback_help: "Obs.: se a última filial visitada não tiver WhatsApp vinculado, será usado o Disparador Padrão.",
                    message_placeholder: "Mensagem",
                    send_file_label: "Enviar arquivo, foto ou vídeo.",
                    file_url_placeholder: "Url do arquivo/vídeo",
                    upload_help: "Faça upload aqui",
                    validating_media: "Validando mídia...",
                    preview_label: "Preview {$0}:",
                    media_types: {
                        image: "da sua imagem",
                        video: "do seu vídeo",
                    },
                    video_not_supported: "Seu navegador não suporta o elemento de vídeo.",
                    required_error: "Este campo precisa ser preenchido",
                    file_url_limit_error: "A URL do arquivo não pode ter mais que 240 caracteres",
                },
                email: {
                    subject_label: "Assunto do e-mail:",
                    subject_placeholder: "Assunto",
                    content_label: "Conteúdo do e-mail:",
                    edit_content_button: "Editar conteúdo",
                    edit_html_button: "Editar HTML",
                },
                sms: {
                    accents_help: "*Todos os acentos serão removidos.",
                },
                rcs: {
                    type_label: "Tipo de mensagem RCS",
                    type: {
                        basic: "Texto curto",
                        single: "Texto (até 1000 caracteres)",
                        card: "Card",
                        carousel: "Carrossel",
                        file: "Arquivo",
                    },
                    text_help: "RCS mantém acentos. Texto curto usa a rota basic; textos maiores usam single.",
                    image: "URL pública da imagem",
                    title: "Título",
                    message: "Mensagem",
                    button: "Botão",
                    button_text: "Texto do botão",
                    button_url: "URL do botão (opcional)",
                    add_button: "Adicionar botão",
                    button_text_required: "Um botão com link precisa de um texto. Sem o texto, o link não é enviado.",
                    card: "Card",
                    add_card: "Adicionar card",
                    file: "URL pública do arquivo",
                    file_name: "Nome do arquivo",
                },
                common: {
                    snippets_help: "Você pode usar as seguintes tags de substituição inteligente no conteúdo:",
                    token_copied: "Token copiado com sucesso!",
                },
            },
        },
        triggers_config: {
            birthday: {
                description: "Esse gatilho será disparado quando um cliente estiver prestes a cumprir aniversário.",
                threshold_label: "Executar quantos dias antes do aniversário? (Deixe 0 para enviar no dia do aniversário)",
            },
            client_date: {
                description: "Esse gatilho é disparado baseado na data de um campo do cliente.",
                field_label: "Qual o campo de data?",
                field_placeholder: "Selecione o campo",
                when_options: {
                    before: "Enviar antes de {$0}",
                    after: "Enviar depois de {$0}",
                    at_date: "Enviar no dia exato de {$0}",
                },
                threshold_label: "Quantos dias {$0} do {$1}?",
                threshold_options: {
                    before: "antes",
                    after: "depois",
                },
                yearly_label: "Enviar anualmente na mesma data (ideal para aniversários)",
            },
            coupon_expiring: {
                description: "Esse gatilho será disparado quando um cupom estiver prestes a expirar.",
                threshold_label: "Executar quantos dias antes de expirar?",
            },
            data_filled: {
                description: "Esse gatilho será disparado quando seus clientes preencherem seus dados.",
            },
            enter_stage: {
                description: "Essa automação será disparada quando quando o cliente entrar na etapa selecionada ou em alguma etapa filho.",
                modal_title: "Mover para qual etapa?",
                close_button: "Fechar",
                select_stage_button: "Selecionar etapa",
            },
            task_moved_to_column: {
                description:
                    "Essa automação será disparada quando uma tarefa for movida para uma das colunas selecionadas do quadro.",
                board_label: "Qual quadro?",
                board_placeholder: "Selecione o quadro",
                column_label: "Coluna(s) de destino",
                no_columns: "Este quadro não possui colunas.",
            },
            feedback_received: {
                description: "Esse gatilho será disparado quando seus clientes preencherem um formulário de opinião.",
                form_label: "Qual Formulário?",
                all_forms: "Todos",
                when_label: "Quando executar?",
                when_options: {
                    all: "Em todas as opiniões",
                    greater: "Com média acima de x",
                    lower: "Com média abaixo de x",
                },
                x_label: "X = ?",
                greater_help: "Você quer executar essa automação quando a opinião tiver a média acima de quanto?",
                lower_help: "Você quer executar essa automação quando a opinião tiver a média abaixo de quanto?",
            },
            inactivity: {
                description: "Esse gatilho será disparado quando seus clientes ficarem um período x sem fazer pedidos.",
                days_label: "Tempo sem pedidos (em dias):",
            },
            joined_segment: {
                description: "Esse gatilho será disparado quando seus clientes passarem a fazer parte de um novo segmento.",
                segment_label: "Qual segmento?",
                segment_placeholder: "Selecione o segmento",
                loading_segments: "Carregando segmentos...",
            },
            left_segment: {
                description: "Esse gatilho será disparado quando seus clientes deixarem de fazer parte de um segmento.",
                segment_label: "Qual segmento?",
                segment_placeholder: "Selecione o segmento",
                loading_segments: "Carregando segmentos...",
            },
            manual: {
                description: "Esse gatilho é disparado manualmente pela tela do cliente ou por uma requisição para a API.",
                fields_label: "Campos do disparo",
                fields_help: "Cada campo vira um item do formulário na tela do cliente e um snippet que você pode usar nas ações. Use apenas letras minúsculas, números e _.",
                name_placeholder: "nome_do_campo",
                types: {
                    text: "Texto",
                    number: "Número",
                    date: "Data",
                    boolean: "Sim/Não",
                },
                required_label: "Obrigatório",
                add_field_button: "Adicionar campo",
                remove_field_title: "Remover campo",
                copy_snippet_title: "Copiar snippet",
                api_title: "Disparar via API",
                api_unsaved: "Salve a automação para ver as instruções da API com o ID dela.",
                api_help: "Autentique com o token Bearer da sua integração. O cliente é identificado por id, e-mail, telefone ou nome, e será criado caso não exista.",
                api_docs_link: "Ver documentação completa",
                api_copy_button: "Copiar exemplo",
                error_key_required: "Informe o nome do campo.",
                error_key_duplicated: "Esse nome já foi usado em outro campo.",
            },
            new_order: {
                description: "Esse gatilho será disparado quando seus clientes fizerem um novo pedido.",
                when_label: "Quando executar?",
                when_options: {
                    all: "Em todos os pedidos",
                    every: "A cada x pedidos",
                    greater: "Todo pedido após x",
                    lower: "Todo pedido antes de x",
                    exact: "No pedido número x",
                },
                x_label: "X = ?",
                every_help: "A cada quantos pedidos você quer executar essa automação?",
                exact_help: "Em qual pedido você quer executar essa ação? 1? 5?",
                filter_value_label: "Filtrar pedidos por valor.",
                min_value_label: "Valor Mínimo",
                max_value_label: "Valor Máximo",
                filter_field_label: "Filtrar pedidos por {$0}.",
                checkbox_tooltip: "Um ou mais se aplicam.",
                placeholder_equal: "Quando for igual...",
            },
            new_quotation: {
                description: "Esse gatilho será disparado quando um novo orçamento for criado.",
                when_label: "Quando executar?",
                when_options: {
                    all: "Em todos os orçamentos",
                    every: "A cada x orçamentos",
                    greater: "Todo orçamento após x",
                    lower: "Todo orçamento antes de x",
                    exact: "No orçamento número x",
                },
                x_label: "X = ?",
                every_help: "A cada quantos orçamentos você quer executar essa automação?",
                exact_help: "Em qual orçamento você quer executar essa ação? 1? 5?",
                filter_value_label: "Filtrar orçamentos por valor.",
                min_value_label: "Valor Mínimo",
                max_value_label: "Valor Máximo",
                filter_field_label: "Filtrar orçamentos por {$0}.",
                placeholder_equal: "Quando for igual...",
            },
            order_status_change: {
                description: "Esse gatilho será disparado quando um pedido tiver seu status alterado.",
                status_label: "Em qual status executar?",
                all_status: "Em todos os status",
                filter_value_label: "Filtrar pedidos por valor.",
                min_value_label: "Valor Mínimo",
                max_value_label: "Valor Máximo",
                filter_field_label: "Filtrar pedidos por {$0}.",
                placeholder_value: "Valor...",
                filter_options: {
                    equals: "Quando for igual a...",
                    contains: "Quando conter...",
                    not_contains: "Quando não conter...",
                    any_value: "Quando existir valor",
                    no_value: "Quando não existir valor",
                },
            },
            periodic: {
                description: "Esse gatilho será disparado em ciclos periódicos.",
                send_monthly: "Enviar mensalmente",
                send_weekly: "Enviar semanalmente",
                at_label: "às",
                week_days: {
                    mon: "Seg",
                    tue: "Ter",
                    wed: "Qua",
                    thu: "Qui",
                    fri: "Sex",
                    sat: "Sáb",
                    sun: "Dom",
                },
            },
            product_group_stock: {
                description: "Esse gatilho será disparado quando estiver perto de acabar o estoque de um grupo de produtos do seu cliente.",
                group_label: "Qual grupo de produto?",
                group_placeholder: "Selecione o grupo de produto",
                any_group: "Qualquer grupo",
                loading_groups: "Carregando grupos...",
                threshold_label: "Executar quantos dias antes do estoque acabar? (Deixe 0 para enviar no dia em que acabar)",
            },
            quotation_expired: {
                description: "Esse gatilho é disparado baseado na data de expiração de orçamentos em aberto.",
                when_options: {
                    before: "Enviar antes da data de expiração",
                    after: "Enviar depois da data de expiração",
                    at_date: "Enviar no dia exato da data de expiração",
                },
                threshold_label: "Quantos dias {$0} da data de expiração ?",
                threshold_options: {
                    before: "antes",
                    after: "depois",
                },
            },
            quotation_status_change: {
                description: "Esse gatilho será disparado quando um orçamento tiver seu status alterado.",
                status_label: "Em qual status executar?",
                all_status: "Em todos os status",
                filter_value_label: "Filtrar orçamentos por valor.",
                min_value_label: "Valor Mínimo",
                max_value_label: "Valor Máximo",
                filter_field_label: "Filtrar orçamentos por {$0}.",
                placeholder_equal: "Quando for igual...",
            },
            quotation_without_order: {
                description: "Esse gatilho será disparado quando um cliente tiver um orçamento, sem nenhum pedido posterior a ele.",
                time_label: "Exatamente quanto tempo atrás?",
                time_placeholder: "Ex: 7",
                unit_label: "Unidade",
                units: {
                    days: "Dias",
                    hours: "Horas",
                    minutes: "Minutos",
                },
                status_label: "Com qual status do orçamento?",
                all_status: "Todos os status",
            },
            quotations_too_long_status: {
                description: "Esse gatilho será disparado quando um cliente estiver com um orçamento estagnado em um determinado status por mais que x dias.",
                status_label: "Qual o status?",
                days_label: "Estagnado a quantos dias?",
                no_status_help: "Você precisa cadastrar os status externos para configurar esse gatilho.",
            },
            reward_reached: {
                description: "Esse gatilho será disparado quando seus clientes atingirem a pontuação necessária para resgatar uma recompensa.",
            },
            reward_used: {
                description: "Esse gatilho será disparado quando seus clientes utilizarem uma recompensa específica.",
                reward_label: "Qual Recompensa?",
                any_reward: "Qualquer uma",
            },
            specific_date: {
                description: "Essa automação será disparada quando a data corresponder as suas configurações de agendamento.",
                date_label: "Data e hora:",
            },
            too_long_on_status: {
                description: "Esse gatilho será disparado quando um cliente estiver com um pedido estagnado em um determinado status por mais que x dias.",
                status_label: "Qual o status?",
                days_label: "Estagnado a quantos dias?",
                filter_orders_label: "Filtrar pedidos por {$0}.",
                filter_types: {
                    equals: "Quando for igual a...",
                    contains: "Quando conter...",
                    not_contains: "Quando não conter...",
                    any_value: "Quando existir valor",
                    no_value: "Quando não existir valor",
                },
                value_placeholder: "Valor...",
                no_event_help: "Você precisa cadastrar os eventos personalizados para configurar esse gatilho.",
            },
            custom_event: {
                description: "Esse gatilho será disparado quando seus clientes realizarem um evento personalizado.",
                event_label: "Qual evento?",
                event_placeholder: "Buscar evento...",
                when_label: "Quando executar?",
                when_options: {
                    all: "Em todas execuções",
                    every: "A cada x execuções",
                    exact: "Na execução número x",
                },
                x_label: "X = ?",
                every_help: "A cada quantas execuções você quer realizar essa automação?",
                exact_help: "Em qual execução você quer realizar essa ação? 1? 5?",
            },
            custom_event_without_order: {
                description: "Esse gatilho será disparado quando o último evento personalizado correspondente do cliente (por exemplo, uma visita a uma página de produto) for mais antigo que o tempo configurado e nenhum pedido tiver sido feito depois dele.",
                match_label: "Como identificar o evento?",
                match_options: {
                    exact: "Um evento personalizado específico",
                    starts_with: "Título do evento começa com",
                    contains: "Título do evento contém",
                },
                event_label: "Qual evento?",
                event_placeholder: "Buscar evento...",
                title_label: "Título do evento",
                title_placeholder: "Ex: Entrou no site - https://loja.com/produto",
                title_help: "Corresponde a eventos de acesso pelo título. Use a URL ou um trecho do caminho da página do produto.",
                time_label: "Exatamente quanto tempo atrás?",
                time_placeholder: "Ex: 2",
                unit_label: "Unidade",
                units: {
                    days: "Dias",
                    hours: "Horas",
                    minutes: "Minutos",
                },
                cooldown_note: "Esse gatilho executa no máximo uma vez por cliente a cada 24 horas.",
            },
        },
    },
    reach_report: {
        title: "Análise RFM",
        frequency_monetary_axis: "Média entre frequência e monetariedade",
        recency_axis: "Recência",
        last_purchase_label: "Última compra",
        to: "a",
        purchases: "compras",
        made_in_last_days: "Feitas nos últimos {$0} dias",
        spent_range: "R${$0} a R${$1}",
        spent_in_last_days: "Gasto nos últimos {$0} dias",
        col_client: "Cliente",
        col_phone: "Telefone",
        col_email: "E-mail",
        col_recency: "Recência",
        col_frequency: "Frequência",
        col_monetary: "Monetário",
        col_rfm_score: "RFM Score",
    },
    report: {
        created_at: "DATA DE CRIAÇÃO:",
        reactivated: "reativados",
        reactivated_tooltip_part1: "Um cliente inativo é um cliente que esta mais que 60 dias sem comprar.",
        reactivated_tooltip_part2: "Ou seja {$0} clientes estavam mais que 60 dias sem comprar e compraram após receber essa automação.",
        converted_clients_label: "Clientes convertidos",
        conversions_label: "Conversões",
        financial_return_label: "Retorno financeiro",
        avg_ticket_label: "Ticket médio",
        conversion_rate_label: "Taxa de conversão",
        table_title: "Clientes convertidos",
        col_name: "Nome",
        col_receipt_date: "Data recebimento",
        col_order_date: "Data pedido",
        col_value: "Valor",
        col_days_since_prev: "Dias desde o pedido anterior",
        col_orders_after: "Pedidos depois da automação",
        unidentified: "(Não identificado)",
        chart_same_day: "No mesmo dia",
        chart_one_day_after: "1 dia depois",
        chart_n_days_after: "{$0} dias depois",
        chart_orders_label: "Pedidos após receber a automação",
    },
};
